/*eslint-disable*/
import {
	Badge,
	Box,
	Flex,
	Image,
	Link,
	Text,
	useColorModeValue,
} from "@chakra-ui/react";
import horizonuilogomain from "assets/img/horizonuilogomain.png";
import { HSeparator } from "components/separator/Separator";
export default function Footer() {
	const textColor = useColorModeValue("#09090B", "white");
	const textColorSecondary = useColorModeValue("gray.600", "white");
	const textFooter = useColorModeValue("#09090B", "white");
	let menuBg = useColorModeValue("white", "navy.800");
	const shadow = useColorModeValue(
		"14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
		"14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
	);
	return (
		<Flex
			zIndex='3'
			flexDirection={{
				base: "column",
			}}
			alignItems='start'
			justifyContent='space-between'
			pb='30px'
			position='relative'
			px={{ base: "20px", xl: "0px" }}
			bg='white'>
			<HSeparator
				mx='auto'
				maxW='1170px'
				mt={{ base: "90px", md: "90px", lg: "100px", xl: "160px" }}
				bg='linear-gradient(270deg, rgba(226, 232, 240, 0.00) 0%, rgba(226, 232, 240, 0.65) 25.52%, #E2E8F0 52.6%, rgba(226, 232, 240, 0.65) 80.21%, rgba(226, 232, 240, 0.00) 100%)'
			/>
			<Flex
				justifyContent='space-between'
				mt='100px'
				w={{ base: "100%", xl: "1170px" }}
				flexDirection={{
					base: "column",
					lg: "row",
				}}
				maxW={{ base: "100%", xl: "1170px" }}
				mx='auto'>
				<Box
					maxW={{
						base: "100%",
						lg: "360px",
					}}
					pe={{
						lg: "30px",
						xl: "0px",
					}}>
					<Link
						display={"flex"}
						alignItems='center'
						justifyContent={"left"}
						mb='20px'
						href='/custom-development/'>
						<Image me='10px' w='179px' src={horizonuilogomain} />
						<Badge
							display={{ base: "flex", lg: "none", xl: "flex" }}
							borderRadius='25px'
							color='#09090B'
							textTransform={"none"}
							bg='none'
							border='1px'
							borderColor='#E2E8F0'
							letterSpacing='0px'
							px='8px'
							py='4px'>
							WORK WITH US
						</Badge>
					</Link>
					<Text
						lineHeight='180%'
						fontSize='sm'
						color='#52525B'
						fontWeight='500'
						letterSpacing='0px'
						w={{ base: "100%", md: "60%", lg: "80%" }}
						mb='26px'>
						You know our products well. Now let's work with them on your
						project. The official custom development services.
					</Text>
					<a
						href='https://www.producthunt.com/posts/horizon-ui?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-horizon&#0045;ui'
						target='blank'>
						<img
							src='https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=342582&theme=light&period=daily'
							alt='Horizon&#0032;UI - Trendiest&#0032;open&#0045;source&#0032;React&#0032;admin&#0032;template | Product Hunt'
							style={{
								width: "250px",
								height: "54px",
								pointerEvents: "none",
							}}
							width='250'
							height='54'
						/>
					</a>
				</Box>
				<Flex
					direction={{ base: "column", md: "row" }}
					w={{ base: "100%", md: "100%", lg: "100%", xl: "690px" }}>
					<Flex
						direction='column'
						me={{ base: "20px", md: "60px", lg: "14px", xl: "60px" }}
						mt={{ base: "30px", md: "40px", lg: "0px" }}>
						<Text
							mb='20px'
							fontSize='md'
							letterSpacing='0px'
							color={textFooter}
							fontWeight='600'>
							Resources
						</Text>
						<Link
							href='https://horizon-ui.com'
							fontSize='sm'
							isExternal='true'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							Admin Template
						</Link>
						<Link
							href='https://horizon-ui.com/pro'
							fontSize='sm'
							isExternal='true'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							PRO Version
						</Link>
						<Link
							href='https://horizon-ui.com/pro-corporate'
							fontSize='sm'
							isExternal='true'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							Horizon Corporate
						</Link>
						<Link
							href='https://horizon-ui.com/boilerplate'
							fontSize='sm'
							isExternal='true'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							Boilerplate Default
						</Link>
						<Link
							href='https://horizon-ui.com/boilerplate-shadcn'
							fontSize='sm'
							isExternal='true'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							Boilerplate Shadcn/UI
						</Link>
						<Link
							href='https://horizon-ui.com/ai-template'
							fontSize='sm'
							isExternal='true'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							AI Template
						</Link>
						<Link
							href='https://horizon-ui.com/landing-kit'
							fontSize='sm'
							isExternal='true'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							Landing Library
						</Link>
						<Link
							href='https://horizon-ui.com/app-generator/'
							fontSize='sm'
							isExternal='true'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							App Generator
						</Link>
						<Flex>
							<Link
								href='https://horizon-ui.com/affiliates'
								fontSize='sm'
								color={textColorSecondary}
								fontWeight='500'
								mb='20px'
								letterSpacing='0px'>
								Affiliates
								<Badge
									ms='6px'
									letterSpacing='0px'
									py='2px'
									px='6px'
									borderRadius='25px'
									color='#09090B'
									textTransform={"none"}
									bg='none'
									border='1px'
									borderColor='#E2E8F0'>
									Earn 30%
								</Badge>
							</Link>
						</Flex>
						<Link
							isExternal='true'
							href='https://blog.horizon-ui.com'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							letterSpacing='0px'>
							Blog
						</Link>
					</Flex>
					<Flex
						direction='column'
						me={{ base: "20px", md: "80px", lg: "50px", xl: "60px" }}
						mt={{ base: "30px", md: "40px", lg: "0px" }}>
						<Text mb='20px' fontSize='md' color={textFooter} fontWeight='600'>
							Help & Support
						</Text>
						<Link
							href='#projects'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							isExternal='true'
							mb='20px'
							letterSpacing='0px'>
							Pages
						</Link>
						<Link
							href='mailto:hello@simmmple.com'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							isExternal='true'
							mb='20px'
							letterSpacing='0px'>
							Contact Us
						</Link>
						<Link
							href='mailto:hello@simmmple.com'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							isExternal='true'
							letterSpacing='0px'
							mb='20px'>
							Support
						</Link>
						<Link
							isExternal='true'
							href='https://feedback.horizon-ui.com/'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							letterSpacing='0px'>
							Roadmap
						</Link>
					</Flex>
					<Flex
						direction='column'
						me={{ base: "20px", md: "80px", lg: "50px", xl: "60px" }}
						mt={{ base: "30px", md: "40px", lg: "0px" }}>
						<Text mb='20px' fontSize='md' color={textFooter} fontWeight='600'>
							Social Media
						</Text>
						<Link
							isExternal='true'
							href='https://github.com/horizon-ui'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							Github
						</Link>
						<Link
							isExternal='true'
							href='https://twitter.com/horizon_ui'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							Twitter
						</Link>
						<Link
							isExternal='true'
							href='https://instagram.com/horizon.ui/'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							mb='20px'
							letterSpacing='0px'>
							Instagram
						</Link>
						<Link
							isExternal='true'
							href='https://www.facebook.com/horizon.ui/'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							letterSpacing='0px'>
							Facebook
						</Link>
					</Flex>
					<Flex direction='column' mt={{ base: "30px", md: "40px", lg: "0px" }}>
						<Text mb='20px' fontSize='md' color={textFooter} fontWeight='600'>
							Legal Resources
						</Text>
						<Link
							isExternal='true'
							href='https://horizon-ui.notion.site/Terms-Conditions-6e79229d25ed48f48a481962bc6de3ee'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							letterSpacing='0px'
							mb='20px'>
							Terms & Conditions
						</Link>
						<Link
							isExternal='true'
							href='https://horizon-ui.notion.site/Privacy-Policy-8addde50aa8e408ca5c5f5811c38f971'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							letterSpacing='0px'
							mb='20px'>
							Privacy Policy
						</Link>
						<Link
							isExternal='true'
							href='https://horizon-ui.notion.site/End-User-License-Agreement-8fb09441ea8c4c08b60c37996195a6d5'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							letterSpacing='0px'
							mb='20px'>
							License
						</Link>
						<Link
							isExternal='true'
							href='https://horizon-ui.notion.site/Refund-Policy-5d5fa25f7fac4978a0be6fcf3036c6ee'
							fontSize='sm'
							color={textColorSecondary}
							fontWeight='500'
							letterSpacing='0px'>
							Refund Policy
						</Link>
					</Flex>
				</Flex>
			</Flex>
			<HSeparator
				mt='75px'
				mb='50px'
				maxW='1170px'
				mx='auto'
				bg='linear-gradient(270deg, rgba(226, 232, 240, 0.00) 0%, rgba(226, 232, 240, 0.65) 25.52%, #E2E8F0 52.6%, rgba(226, 232, 240, 0.65) 80.21%, rgba(226, 232, 240, 0.00) 100%)'
			/>
			<Flex mx='auto'>
				<Text
					me='4px'
					letterSpacing='0px'
					fontSize='sm'
					fontWeight='500'
					textColor={textColorSecondary}>
					Horizon UI © 2024 Copyright. All rights reserved.
				</Text>
			</Flex>
		</Flex>
	);
}
